import React from 'react';

// 进度条组件
const ProgressBar = ({ formStatuses, totalPages }) => {
  // 计算已完成的表单数量
  const completedForms = formStatuses ? Object.values(formStatuses).filter(status => status === 'completed').length : 0;
  const progress = totalPages > 0 ? (completedForms / totalPages) * 100 : 0;
  

  
  return (
    <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
      <div 
        className={`h-2 rounded-full transition-all duration-300 ${
          progress === 100 ? 'bg-green-600' : 'bg-blue-600'
        }`}
        style={{ width: `${progress}%` }}
      />
      <div className="text-sm text-gray-600 mt-2">
        进度: {completedForms} / {totalPages} 已完成 ({Math.round(progress)}%)
      </div>
    </div>
  );
};

export default ProgressBar; 